import './App.css';
import Weatherapp from './components/Weatherapp';

function App() {
  return (
    <div className="App">
      <Weatherapp/>
    </div>
  );
}

export default App;
